import React from 'react';
import { Clock, CalendarDays, FileText, AlertCircle } from 'lucide-react';

export default function StatCard({
  label,
  value,
  sub,
  icon: Icon,
  iconBg = "bg-blue-50",
  iconColor = "text-blue-500",
  cardBg = "bg-white",
  border = "border-gray-200",
  badge = null,
  status = null,
  translatedStatus = null,
  translatedBadge = null,
  description = null,
  bills = [],
  ...props
}) {
  return (
    <div className={`rounded-xl border relative ${border} ${cardBg} p-4 shadow-sm hover:shadow-md transition-shadow duration-200`}>
      {/* Header with icon and label */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className={`rounded-lg ${iconBg} p-2`}>
            {Icon && <Icon className={`h-5 w-5 ${iconColor}`} />}
          </div>
          <span className="text-sm font-medium text-gray-600">
            {label}
          </span>
        </div>
        {badge && (
          <span className={`text-xs font-medium px-2 py-1 rounded-full ${
            badge === "pending" ? "bg-orange-100 text-orange-700" :
            badge === "high" ? "bg-red-100 text-red-700" :
            badge === "medium" ? "bg-yellow-100 text-yellow-700" :
            badge === "low" ? "bg-green-100 text-green-700" :
            "bg-gray-100 text-gray-700"
          }`}>
            {translatedBadge || badge}
          </span>
        )}
      </div>

      {/* Main value */}
      <div className="mt-3">
        <p className="text-2xl font-semibold text-gray-900">
          {value}
        </p>
        {sub && (
          <p className="text-sm text-gray-500 mt-1">
            {sub}
          </p>
        )}
      </div>

      {/* Optional status indicator for visits */}
      {status && (
        <div className="mt-3 pt-3 border-t border-gray-200 ">
          <span className={`text-xs font-medium px-2 py-1 rounded-full ${
            status === "completed" ? "bg-green-100 text-green-700" :
            status === "scheduled" ? "bg-blue-100 text-blue-700" :
            status === "cancelled" ? "bg-red-100 text-red-700" :
            status === "in_progress" ? "bg-yellow-100 text-yellow-700" :
            "bg-gray-100 text-gray-700"
          }`}>
            {translatedStatus || status}
          </span>
        </div>
      )}
      {description && (
        <div className="mt-3 pt-3 border-t border-gray-200 lg:absolute bottom-4 left-4 right-4">
          <p className={`text-xs font-medium px-2 py-1 rounded-full w-max ${
            badge === "pending" ? "bg-orange-100 text-orange-700" :
            badge === "high" ? "bg-red-100 text-red-700" :
            badge === "medium" ? "bg-yellow-100 text-yellow-700" :
            badge === "low" ? "bg-green-100 text-green-700" :
            "bg-gray-100 text-gray-700"
          }`}>{description}</p>
        </div>
      )}

      {/* Optional bills list */}
      {bills && bills.length > 0 && (
        <div className="mt-3 pt-3 border-t border-gray-200">
          <div className="space-y-1">
            {bills.slice(0, 2).map((bill, index) => (
              <div key={index} className="flex justify-between text-sm">
                <span className="text-gray-600">{bill.description || `Bill #${index + 1}`}</span>
                <span className="font-medium text-gray-900">{parseFloat(bill.amount).toFixed(2)} MAD</span>
              </div>
            ))}
            {bills.length > 2 && (
              <p className="text-xs text-gray-500">+{bills.length - 2} more</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}